/***************************************************
 Arsenal Asset Source initAAdeferredLoad()
***************************************************/
// Loads an url of a video when the user resizes it's window
// Use:
// - data-aa-src for images and vide src
//   IF A VIDEO AUTOPLAYS ON LOAD - Set the video tag data-autoplay="true"
// - data-aa-back-src for elements with background images
// 
// REQUIRES: 
// * util-set-attribute-if-visible.js
//   |_ util-set-attribute.js
const initAAdeferredLoad = function (elmnts, isBackground) {
  const isBckgrnd = (isBackground) ? isBackground : false;

  setObservers(elmnts, isBckgrnd);

  function playVideo(v) {
    v.loop = true;
    v.playsInline = true;
    v.muted = true;
    v.load();
    v.play();
  }// playVideo()

  function setSourceFollowup(elmnt) {
    if (elmnt.dataset.aaSrc) {
      elmnt.dataset.aaSrc = "";
    }
    else {
      if (elmnt.dataset.aaBackSrc) elmnt.dataset.aaBackSrc = "";
    }

    // Is a video - we play the last video src if autoplay is on
    if (elmnt.tagName.toLowerCase() == "source" &&
      elmnt.parentElement.dataAutoplay && elmnt.parentElement.dataAutoplay
      && (elmnt == elmnt.parentElement.lastElementChild)) {
      playVideo(elmnt.parentElement);
    }
  }// setSource()

  function setObservers(elmnts, isBck) {
    const isB = (isBck) ? isBck : false;
    const attrName = isBck ? "backgroundImage" : "src";

    elmnts.map(function (elm) {
      const attrVal = isB ? elm.dataset.aaBackSrc : elm.dataset.aaSrc;
      setAttribute(elm, attrName, attrVal, setSourceFollowup);
    });
  }// setObservers()
}// initAAdeferredLoad()

window.addEventListener('load', (event) => {
  if (document.querySelector("[data-aa-src]")) initAAdeferredLoad(Array.from(document.querySelectorAll("[data-aa-src]")));
  if (document.querySelector("[data-aa-back-src]")) initAAdeferredLoad(Array.from(document.querySelectorAll("[data-aa-back-src]")), true);
});